// extracted by mini-css-extract-plugin
export default {"spinner":"bookingPricing_spinner__xwtfQ"};